import React, { useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Chip } from '@mui/material';
import SchoolIcon from '@mui/icons-material/School';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Course } from '../../../types/Course';
import { Institution } from '../../../types/Institution';
import { InstitutionTypeFilter } from '../../../services/adapters/queries/institutionsQueryFunction';
import { verticalCopy } from '../../../utils/constants/verticalCopy';
import './CoursesSection.css';

const CoursesSection = ({
  dictatedCoursesByInstitution,
  institutions,
  searchType
}: {
  dictatedCoursesByInstitution: Map<string, Course[]>;
  institutions: Institution[] | undefined;
  searchType: InstitutionTypeFilter;
}) => {
  const [expanded, setExpanded] = useState(false);

  const handleAccordionChange = () => (_: any, isExpanded: any) => {
    setExpanded(isExpanded ? true : false);
  };

  const handleDetailsClick = () => {
    setExpanded(false);
  };

  const institutionsById = new Map(institutions?.map((i) => [i.value, i.label]));
  const entries = Array.from(dictatedCoursesByInstitution.entries());
  const filteredEntries = institutions
    ? entries.filter(([institutionId]) => institutionsById.has(institutionId))
    : [];

  const dictatedCoursesByInstitutionComponents: JSX.Element[] = filteredEntries.map(
    ([institutionId, courses]) => {
      const institutionLabel = institutionsById.get(institutionId);

      return (
        <React.Fragment key={institutionId}>
          <p>{institutionLabel}</p>
          <ul className="dictatedCourses">
            {courses.map((course: Course) => (
              <Chip key={course.label} label={course.label} size="small" />
            ))}
          </ul>
        </React.Fragment>
      );
    }
  );

  const institutionCount = filteredEntries.length;
  const courseCount = filteredEntries.reduce((acc, [, courses]) => acc + courses.length, 0);
  const summaryText = verticalCopy[searchType].summary(institutionCount, courseCount);

  return (
    <div>
      <Accordion
        slotProps={{ transition: { unmountOnExit: true } }}
        expanded={expanded}
        onChange={handleAccordionChange()}
        sx={{
          boxShadow: 'none',
          border: 'none',
          '&:before': {
            display: 'none'
          }
        }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header">
          <div className="summary">
            <SchoolIcon className="schoolIcon" />
            <b>{summaryText}</b>
          </div>
        </AccordionSummary>
        <AccordionDetails onClick={handleDetailsClick}>
          {dictatedCoursesByInstitutionComponents.flat()}
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default CoursesSection;
